import { mediaById } from './media'
import type { Post } from '../types'

export const posts: Post[] = [
  {
    id: 'p1',
    authorId: 'lucas',
    media: mediaById('running').url,
    caption: {
      'pt-BR':
        'Trilha antes do trabalho. Saí sem meta de ritmo e voltei com o melhor 10 km do ano.',
      'en-US':
        'Trail before work. Went out with no pace goal and came back with my best 10 km of the year.',
    },
    context: {
      category: 'running',
      activity: { 'pt-BR': '12,4 km · 1h02 · 5:00/km', 'en-US': '12.4 km · 1h02 · 5:00/km' },
      streak: 18,
      achievement: { 'pt-BR': 'Recorde pessoal', 'en-US': 'Personal best' },
      xp: 100,
    },
    likes: 184,
    comments: 12,
    hoursAgo: 3,
    location: { 'pt-BR': 'Parque da Cantareira', 'en-US': 'Cantareira Park' },
  },
  {
    id: 'p2',
    authorId: 'marina',
    media: mediaById('mindfulness').url,
    caption: {
      'pt-BR':
        'Sétimo dia seguido de respiração guiada. Cinco minutos mudaram o meu começo de manhã.',
      'en-US':
        'Seventh day in a row of guided breathing. Five minutes changed how my mornings start.',
    },
    context: {
      category: 'mindfulness',
      activity: { 'pt-BR': '5 min de respiração', 'en-US': '5 min breathing' },
      streak: 7,
      achievement: { 'pt-BR': 'Semana de Ferro', 'en-US': 'Iron Week' },
      xp: 85,
    },
    likes: 96,
    comments: 8,
    hoursAgo: 6,
  },
  {
    id: 'p3',
    authorId: 'rafael',
    media: mediaById('strength').url,
    caption: {
      'pt-BR':
        'Agachamento em 120 kg com técnica limpa. Levei sete meses para chegar aqui sem dor.',
      'en-US':
        'Squat at 120 kg with clean technique. It took seven months to get here pain-free.',
    },
    context: {
      category: 'strength',
      activity: { 'pt-BR': '5×3 · 120 kg', 'en-US': '5×3 · 120 kg' },
      streak: 31,
      achievement: { 'pt-BR': 'Novo 1RM', 'en-US': 'New 1RM' },
      xp: 100,
    },
    likes: 143,
    comments: 21,
    hoursAgo: 11,
  },
  {
    id: 'p4',
    authorId: 'pedro',
    media: mediaById('cycling').url,
    caption: {
      'pt-BR': 'Subida longa no fim da tarde. Cadência estável do começo ao fim.',
      'en-US': 'Long climb late in the afternoon. Steady cadence from start to finish.',
    },
    context: {
      category: 'cycling',
      activity: { 'pt-BR': '48 km · 720 m de ganho', 'en-US': '48 km · 720 m gain' },
      streak: 14,
      xp: 90,
    },
    likes: 77,
    comments: 5,
    hoursAgo: 20,
    location: { 'pt-BR': 'Serra do Japi', 'en-US': 'Serra do Japi' },
  },
  {
    id: 'p5',
    authorId: 'juliana',
    media: mediaById('swimming').url,
    caption: {
      'pt-BR': 'Série de 10×100 m. O pace caiu dois segundos em relação ao mês passado.',
      'en-US': 'Set of 10×100 m. Pace dropped two seconds compared to last month.',
    },
    context: {
      category: 'swimming',
      activity: { 'pt-BR': '10×100 m · 1:42/100 m', 'en-US': '10×100 m · 1:42/100 m' },
      streak: 9,
      xp: 75,
    },
    likes: 64,
    comments: 4,
    hoursAgo: 26,
  },
  {
    id: 'p6',
    authorId: 'camila',
    media: mediaById('nutrition').url,
    caption: {
      'pt-BR':
        'Preparo a refeição pós-treino na noite anterior. É o hábito que mais sustenta os outros.',
      'en-US':
        'I prep my post-workout meal the night before. It is the habit that holds the others up.',
    },
    context: {
      category: 'nutrition',
      streak: 22,
      xp: 95,
    },
    likes: 58,
    comments: 9,
    hoursAgo: 31,
  },
]
